import { render } from "./StakeCard.vue?vue&type=template&id=797f0f06"
import script from "./StakeCard.vue?vue&type=script&lang=js"
export * from "./StakeCard.vue?vue&type=script&lang=js"

import "./StakeCard.vue?vue&type=style&index=0&id=797f0f06&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/weapsmithing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__